import React, { useState, useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";
import { getIndices, fmtPrice, STREAM_URL } from "@/lib/api";
import { TrendingUp, TrendingDown, Radio } from "lucide-react";

export const MarketMarquee = () => {
  const [data, setData] = useState([]);
  const [live, setLive] = useState(false);
  const esRef = useRef(null);

  useEffect(() => {
    getIndices().then(setData).catch(() => {});
    const es = new EventSource(STREAM_URL);
    esRef.current = es;
    es.onmessage = (e) => {
      try {
        const p = JSON.parse(e.data);
        if (p.indices) setData(p.indices);
        setLive(true);
      } catch (err) {
        console.debug("stream parse skipped:", err);
      }
    };
    es.onerror = () => { setLive(false); };
    return () => es.close();
  }, []);

  if (!data.length) return null;
  return (
    <div className="border-y border-border bg-app flex items-center" data-testid="market-marquee">
      <div className="flex items-center gap-1.5 px-3 py-2 border-r border-border shrink-0">
        <Radio size={12} className={live ? "text-bull live-dot" : "text-tertiary"} />
        <span className="text-[9px] font-mono uppercase tracking-widest text-tertiary">{live ? "Stream" : "…"}</span>
      </div>
      <Marquee speed={40} gradient={false} pauseOnHover>
        {data.concat(data).map((s, i) => {
          const up = s.change_pct >= 0;
          return (
            <div key={i} className="flex items-center gap-2 px-5 py-2 border-r border-border-subtle">
              <span className="font-mono font-bold text-sm text-white">{s.symbol}</span>
              <span className="font-mono text-sm text-secondary">${fmtPrice(s.price)}</span>
              <span className={`font-mono text-sm flex items-center gap-0.5 ${up ? "text-bull" : "text-bear"}`}>
                {up ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                {up ? "+" : ""}{s.change_pct}%
              </span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};
